import React from 'react';

import { IBadgeFields } from '../../../types/contentful';

import RichText from '../RichText';

import {
  Logo,
  BadgeWrapper,
  TextWrapper,
  HeaderText,
  LogoWrapper
} from './styles';

export function Badge({ badgeHeader, badgeImage, badgeCopy }: IBadgeFields) {
  const { file, description } = badgeImage?.fields ?? {};

  return (
    <BadgeWrapper>
      {file?.url && (
        <LogoWrapper>
          <Logo
            src={`https:${file?.url}`}
            alt={description ?? 'Badge Image'}
            height={120}
            width={120}
          />
        </LogoWrapper>
      )}
      <TextWrapper>
        <HeaderText
          as="h3"
          fontSize={{ 0: 'h3_0', tablet: 'h3_tablet' }}
          fontWeight="h3"
        >
          {badgeHeader}
        </HeaderText>
        {badgeCopy && <RichText data={badgeCopy} />}
      </TextWrapper>
    </BadgeWrapper>
  );
}
